import { SortingState } from '@tanstack/react-table';
import { Moment } from 'moment';
import { Where } from '../filters';

// ========== types used in V2 requests ==========

export type RequestOrder = { member: string; direction: string; priority: number };

export type RequestSegment = { id: string; conditions: Where };

export type TimeIntervalQuery = { from: string | Moment; until: string | Moment };

export type PaginatedResponse<T> = {
  meta: {
    page: number;
    pageTotal: number;
    pageSize?: number;
    total: number;
  } & Record<string, any>;
  payload: T;
};

export type PayloadResponse<T, M> = {
  meta: M;
  payload: T;
};

// ========== types used in V3 requests ==========

export enum SortingDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export type Sorting<M extends string = string> = {
  member: M;
  direction: SortingDirection;
};

export type DateRange = {
  start: string;
  end: string;
};

export const mapSortingToOrder = <M extends string>(sorting: SortingState): Sorting<M>[] =>
  sorting.map((s) => ({
    member: s.id as M,
    direction: s.desc ? SortingDirection.Desc : SortingDirection.Asc,
  }));
